export const text = {
  CEOMessage: "CEO Message",
  Quicklinks: "Quicklinks",
  Edit: "Edit",
  Add: "Add",
  selectbanner: "Select Banner",
  selectvideo: "Select Video",
  Message: "Message",
  EnterName: "Enter Name",
  EnterLink: "Enter Link",
  selectIcon: "Select Icon",
  AreyousureyouwanttodeletethisQuicklinks:
    "Are you sure you want to delete this Quicklinks?",
  NoQuicklinks: "No Quicklinks",
  CEOMessageupdatedsuccessfully: "CEO Message updated successfully!",
  QuickLinkupdatedsuccessfully: "Quick Link updated successfully!",
  Allfieldsarerequired: "All fields are required",
  Message: "Message",
};
